import { useEffect, useState } from 'react';
import { Helmet } from 'react-helmet-async';
import { ToastContainer } from 'react-toastify';
// style
import style from './home.module.css';
// components
import Header from '../../components/Header/Header';
import Services from '../../components/Service/Services';
import Playgrounds from '../../components/Playgrounds/Playgrounds';
import Price from '../../components/Price/Price';
import Faq from '../../components/Faq/Faq';
import Contact from '../../components/Contact/Contact';

const Home = () => {
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    window.scrollTo(0, 0);
    document.body.style.overflow = 'hidden'; // Отключаем скролл при загрузке

    const timer = setTimeout(() => {
      setLoading(false);
      document.body.style.overflow = 'visible'; // Возвращаем скролл после загрузки
    }, 300); // 1 секунда для имитации загрузки

    return () => {
      clearTimeout(timer);
      document.body.style.overflow = 'visible'; // На случай размонтирования компонента
    };
  }, []);

  return (
    <>
      <Helmet>
        <title>
          Sparta – Лазертаг, Пейнтбол, Гидробол и Скайпарк в Казани для детей и
          взрослых
        </title>
        <meta
          name="description"
          content="Клуб Sparta — лучший выбор для активного отдыха в Казани! Лазертаг, пейнтбол и гидробол для детей и взрослых."
        />
        <meta
          name="description"
          content="Организация игр в лазертаг, пейнтбол и гидробол для детей и взрослых в Казани."
        />
        <meta
          property="og:title"
          content="Sparta – Лазертаг, Пейнтбол, Гидробол и Скайпарк в Казани для детей и
          взрослых"
        />
        <meta
          property="og:description"
          content="Проведение активных игр для всех возрастов в Казани."
        />
      </Helmet>

      {loading ? (
        <div className="loaderWrapper">
          <div className="loaderPage"></div>
        </div>
      ) : (
        <main className={style.p}>
          <Header />
          <Services />
          <Playgrounds />
          <Contact
            bg={false}
            text="Не можете определиться с выбором локации, приезжайте лично на любую из них."
          />
          <Price />
          <Contact
            bg={true}
            text=" Остались вопросы? Звоните или Отправьте заявку, всё обсудим!"
          />
          <Faq />
          <ToastContainer />
        </main>
      )}
    </>
  );
};

export default Home;
